import Vue from 'vue'
// models component
import ShipLogBook from '@/models/ShipLogBook'

export default class ShipLogBookFetch {
    // Ship LogBook Fetch
    static of(shipId, params) {
        return Promise.resolve()
            .then(function () {
                ShipLogBook.deleteAll()
                return ShipLogBook.api()
                    .fetch(shipId, params)
                    .then(function (result) {
                        console.log('ShipLogBook.all()', ShipLogBook.all())
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
